var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 27C20.9558 27 27 20.9558 27 13.5C27 6.04416 20.9558 0 13.5 0C6.04416 0 0 6.04416 0 13.5C0 20.9558 6.04416 27 13.5 27Z",
    fill: "#0DAC98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1217 14.6672V14.6655C15.0289 14.6722 14.5505 14.7009 13.4832 14.7009C12.631 14.7009 12.0311 14.6756 11.8201 14.6655V14.668C8.53964 14.5237 6.09108 13.9525 6.09108 13.2691C6.09108 12.5865 8.53964 12.0153 11.8201 11.8684V14.0993C12.0345 14.1145 12.6487 14.1508 13.4975 14.1508C14.5159 14.1508 15.0264 14.1086 15.1217 14.1002V11.8701C18.3955 12.0161 20.8381 12.5873 20.8381 13.2691C20.8381 13.9525 18.3955 14.522 15.1217 14.6672ZM15.1217 11.6381V9.64178H19.6898V6.59753H7.25208V9.64178H11.8201V11.6373C8.10764 11.8077 5.31567 12.5434 5.31567 13.4243C5.31567 14.3052 8.10764 15.0401 11.8201 15.2114V21.6087H15.1217V15.2097C18.8283 15.0393 21.6135 14.3043 21.6135 13.4243C21.6135 12.5443 18.8283 11.8094 15.1217 11.6381Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/_usdt.baa42f48e57f1da6460a8c043449d0d4.svg";
export { ForwardRef as ReactComponent };